import React from "react";
import "../../../styles/spinner.scss";

const Spinner = ({ show, text, showContainer }) => {
    return (
        <>
            {show && (
                <div
                    className={
                        showContainer ? "spinner show-container" : "spinner"
                    }
                >
                    <div className="mt-3 mb-0 d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                            <p className="w-100 mb-0 text-center">
                                <span className="visually-hidden">Loading...</span>
                            </p>
                        </div>
                    </div>
                    <p className="w-100 mt-0 mb-2 text-center cds-text-light">
                        {text}
                    </p>
                </div>
            )}
        </>
    );
};

export default Spinner;
